// Func = limiting Scope for this file
//images cut

var toppoint = window.innerWidth * 0.60;
var bottompoint = window.innerWidth * 0.48;

if(document.getElementById('home') && document.getElementById('uvptext')){
    var firstpoint = document.getElementById('uvptext').offsetLeft + 196;
    var secpoint = document.getElementById('uvptext').offsetLeft - 84;
    createpolygonshome();

    //hometestimonials
    var tcite = document.getElementsByClassName('testimonialcite');
    for(var i = 0; i < tcite.length ; i++){ 
        var txt = tcite[i].innerHTML.split("|");
        tcite[i].innerHTML = txt[0] + '<span>' + txt[1] + '</span>';
    }

    //next go to
    var nextbtn = document.getElementsByClassName('next');
    for(var i = 0; i < nextbtn.length; i++){
        //console.log(nextbtn[i].getElementsByTagName('a')[0])
        nextbtn[i].getElementsByTagName('a')[0].addEventListener('click', function(e){
            e.preventDefault();
            var to = this.getAttribute('href').split('#');
            animateto(to[1]);
        });
    }
}

if(document.getElementById('default')){
    createpolygondefault();
}



(function(){

    //all btn wraps a span
    var allbtn = document.getElementsByClassName('btn');
    for( var i = 0; i < allbtn.length; i++){
        var btncontent = allbtn[i].innerHTML;
        allbtn[i].innerHTML = '<span>' + btncontent + '</span>';
    }


    //check if is IE using function at the bottom
    //console.log(isIE());
    if (isIE()){
        document.getElementById('content').classList.add('explorer');
    }

	window.addEventListener('scroll', function(){
        scrollDown();
	});

	window.onresize = function(){
        resizeWindow();
	}

	document.getElementById('start-content').classList.add('ready');

    resizeWindow();


    if(document.getElementsByClassName('btnSubmit')[0]){
        document.getElementsByClassName('btnSubmit')[0].addEventListener('click', function(){
            console.log('holi!');
            setTimeout(function(){
                document.getElementById('thankyou').style.display = 'none';
            }, 6000);
        });
    }


	$(document).ready(function () {




		$('.book-now').on('click', function () {
			if (typeof ga == 'function') ga('send', 'event', 'reservations', 'click', 'book now');
		});
		//this class should be add to the header widget submit button
		$('.bookNow').on('click', function () {
			if (typeof ga == 'function') ga('send', 'event', 'header widget', 'click', 'book now');
		});

		//Check in and check out datepicker for booking engine
		$( "#CheckIn" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			changeMonth: true,
			numberOfMonths: 1,
			minDate: 0,
			onSelect: function( selectedDate ) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 3);
				$( "#CheckOut" ).datepicker( "setDate", newDate );
				$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );
			}
		});
		$( "#CheckOut" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			changeMonth: true,
			numberOfMonths: 1,
			onSelect: function( selectedDate ) {
				//$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
			}
		});



		// Map: Return to previous page button. Change body id to match map template's name.
		//$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');
		
	});

}());

function scrollDown(){

	var top = window.pageYOffset;
	if(top > 50){
		document.getElementById('header').classList.add('down');
	} else {
        document.getElementById('header').classList.remove('down');
	}
}

function resizeWindow(){

    if(document.getElementById('home') &&  document.getElementById('uvptext')){
        firstpoint = document.getElementById('uvptext').offsetLeft + 196;
        secpoint = document.getElementById('uvptext').offsetLeft - 84;
        document.getElementById('headerpol').setAttribute('points', '0, 0, ' + firstpoint + ', 0, ' + secpoint + ', 750, 0, 750');
		var welcome = document.getElementsByClassName('intro-content-home')[0].getElementsByClassName('wrapper')[0];
		//console.log(welcome.offsetWidth);
        document.getElementById('welcomepol').setAttribute('points', '0, 0, ' + (welcome.offsetWidth * 61)/100 + ', 0, ' + (welcome.offsetWidth * 36)/100 + ', 750, 0, 750');
	}

    toppoint = window.innerWidth * 0.60;
    bottompoint = window.innerWidth * 0.48;

}

function Polygon() {
    var pointList = [];
    this.node = document.createElementNS('http://www.w3.org/2000/svg', 'polygon');

    function build(arg) {
        var res = [];
        for (var i = 0, l = arg.length; i < l; i++) {
            res.push(arg[i].join(','));
        }
        return res.join(' ');
    }

    this.attribute = function (key, val) {
        if (val === undefined) return this.node.getAttribute(key);
        this.node.setAttribute(key, val);
    };

    this.getPoint = function (i) {
        return pointList[i]
    };

    this.setPoint = function (i, x, y) {
        pointList[i] = [x, y];
        this.attribute('points', build(pointList));
    };

    this.points = function () {
        for (var i = 0, l = arguments.length; i < l; i += 2) {
            pointList.push([arguments[i], arguments[i + 1]]);
        }
        this.attribute('points', build(pointList));
    };

    this.points.apply(this, arguments);
}

function createpolygonshome(){
    //header image
    var polygon = new Polygon();
    polygon.setPoint(0,0,0); // set point and automatically re-build points
    polygon.points(0, 0, firstpoint, 0, secpoint, 750, 0, 750); // set everything
    polygon.node; // refer to the actual SVG element
    polygon.node.id = 'headerpol';
    var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg.appendChild(polygon.node);
    document.getElementsByClassName('slide0')[0].appendChild(svg);
    svg.setAttribute('width', firstpoint);
    svg.setAttribute('height', 750);
    //svg.classList.add('svgpol');
    var oldsvg = svg.innerHTML;
    svg.innerHTML = '<defs><clipPath id ="svgpolygon">' + oldsvg + '</clipPath></defs>';

    //welcome image
    var polygon2 = new Polygon();
    polygon2.setPoint(0,0,0); // set point and automatically re-build points
    polygon2.points(0, 0, 700, 0, 400, 700, 0, 700); // set everything
    polygon2.node; // refer to the actual SVG element
    polygon2.node.id = 'welcomepol';
    var svg2 = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg2.appendChild(polygon2.node);
    svg2.setAttribute('width', 400);
    svg2.setAttribute('height', 750);
    document.getElementsByClassName('image--welcome')[0].appendChild(svg2);
    var oldsvg2 = svg2.innerHTML;
    svg2.innerHTML = '<clipPath id ="welcomesvg">' + oldsvg2 + '</clipPath>';

    //why us image
    var polygon3 = new Polygon();
    polygon3.setPoint(0,0,0); // set point and automatically re-build points
    polygon3.points(0, 0, 700, 0, 400, 700, 0, 700); // set everything
    polygon3.node; // refer to the actual SVG element
    polygon3.node.id = 'whypol';
    var svg3 = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg3.appendChild(polygon3.node);
    svg3.setAttribute('width', 400);
    svg3.setAttribute('height', 750);
    document.getElementsByClassName('image--reasons')[0].appendChild(svg3);
    var oldsvg3 = svg3.innerHTML;
    svg3.innerHTML = '<clipPath id ="whysvg">' + oldsvg3 + '</clipPath>';
}

function createpolygondefault() {
    //header image
    resizeWindow();

    var polygon = new Polygon();
    polygon.setPoint(0, 0, 0);
    polygon.points(0, 0, toppoint, 0, bottompoint, 350, 0, 350);
    polygon.node; //
    polygon.node.id = 'headermask';

    var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg.appendChild(polygon.node);
    document.getElementsByClassName('target__svg')[0].appendChild(svg);
    var oldsvg = svg.innerHTML;
    svg.setAttribute('width', toppoint);
    svg.setAttribute('height', bottompoint);
    svg.innerHTML = '<defs><clipPath id ="svgpolygon">' + oldsvg + '</clipPath></defs>';
}



/* Sample function that returns boolean in case the browser is Internet Explorer*/
function isIE() {
    var ua = navigator.userAgent;
    /* MSIE used to detect old browsers and Trident used to newer ones*/
    //var is_ie = ua.indexOf("MSIE ") > -1 || ua.indexOf("Trident/") > -1;
    var msie = ua.indexOf('MSIE ');
    if (msie > 0) {
        // IE 10 or older => return version number
        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
    }

    var trident = ua.indexOf('Trident/');
    if (trident > 0) {
        // IE 11 => return version number
        var rv = ua.indexOf('rv:');
        return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
    }

    var edge = ua.indexOf('Edge/');
    if (edge > 0) {
        // Edge (IE 12+) => return version number
        return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
    }
    //return is_ie;
}

//animate to
function animateto(target){
   var goto = document.getElementById(target).offsetTop + 50;
   var diff = window.pageYOffset;
   var time = 0;
   var position = diff;

   var animation = setInterval(frame);
   function frame(){
       time += 1 / 100;
       position = easeInOutQuad(time * 100 / 4, time, diff, goto, 4);
       if (position >= goto) {
               clearInterval(animation);
        } else {
               //diff = diff + 5;
               window.scrollTo(0, position);
       }

   }
}
function easeInOutQuad(x, t, b, c, d) {
    if ((t /= d / 2) < 1) {
        return c / 2 * t * t + b;
    } else {
        return -c / 2 * ((--t) * (t - 2) - 1) + b;
    }
}